var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38281 16.8203C6.40365 17.8411 7.64323 18.3516 9.10156 18.3516C10.5599 18.3516 11.7995 17.8411 12.8203 16.8203C13.8411 15.7995 14.3516 14.5599 14.3516 13.1016C14.3516 11.6432 13.8411 10.4036 12.8203 9.38281C11.7995 8.36198 10.5599 7.85156 9.10156 7.85156C7.64323 7.85156 6.40365 8.36198 5.38281 9.38281C4.36198 10.4036 3.85156 11.6432 3.85156 13.1016C3.85156 14.5599 4.36198 15.7995 5.38281 16.8203ZM16.1016 18.3516L21.8984 24.1484L20.1484 25.8984L14.3516 20.1016V19.1719L14.0234 18.8438C12.638 20.0469 10.9974 20.6484 9.10156 20.6484C6.98698 20.6484 5.18229 19.9193 3.6875 18.4609C2.22917 17.0026 1.5 15.2161 1.5 13.1016C1.5 10.987 2.22917 9.20052 3.6875 7.74219C5.18229 6.2474 6.98698 5.5 9.10156 5.5C11.2161 5.5 13.0026 6.2474 14.4609 7.74219C15.9193 9.20052 16.6484 10.987 16.6484 13.1016C16.6484 13.8672 16.4661 14.7422 16.1016 15.7266C15.737 16.6745 15.3177 17.4401 14.8438 18.0234L15.1719 18.3516H16.1016Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.deea4165584ec1bc219686694dd97913.svg";
export { ForwardRef as ReactComponent };